/*
  Landscape Design page — motion.
  1. Hero entrance (heading lines rise behind a mask, frame fades/scales, plate slides in)
  2. Before/after auto-sweep the first time a compare card scrolls into view
  (Quiz transitions live in the quiz section's own script.)

  The <html class="ld-motion"> flag is added synchronously by a tiny inline script in
  the hero section, only when the visitor has not asked for reduced motion. Every
  "hidden until revealed" style is scoped under that class, so with JS off or
  reduced-motion on, everything simply renders in its final state.
*/
(function () {
  'use strict';
  if (window.__ldMotion) return;
  window.__ldMotion = true;

  var motionOK = document.documentElement.classList.contains('ld-motion');

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- 1. Hero entrance ---------- */
  function hero() {
    var heroes = document.querySelectorAll('.ld-hero');
    Array.prototype.forEach.call(heroes, function (el) {
      // Two frames so the initial (hidden) styles are painted before the transition starts.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.classList.add('is-ready');
          // Heading highlight: marker and underline sit inside the line mask's padding,
          // so they start with the entrance (the theme delays the sweep 0.5s itself).
          // The circle ring extends well outside the text, so it waits for the mask.
          var wraps = el.querySelectorAll('[data-ld-highlight]');
          var hasCircle = !!el.querySelector('[data-ld-highlight] [data-highlight=circle]');
          function arm() { Array.prototype.forEach.call(wraps, function (w) { w.setAttribute('animate', ''); }); }
          if (!hasCircle) arm();
          setTimeout(function () {
            el.classList.add('is-settled');
            if (hasCircle) requestAnimationFrame(arm);
          }, 1500);
        });
      });
    });
  }

  /* ---------- Shared observer ----------
     IntersectionObserver honours clip-path, so an element clipped to zero width
     never intersects. We therefore observe a small sentinel placed inside each
     target's parent (unclipped) and map it back to the target. */
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var sentinel = entry.target;
          io.unobserve(sentinel);
          var el = sentinel.__ldTarget;
          if (!el) return;
          if (el.hasAttribute('data-ld-compare')) sweep(el);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0 })
    : null;

  function watch(el) {
    if (el.__ldWatched) return;
    el.__ldWatched = true;
    if (!io) return;
    var s = document.createElement('span');
    s.className = 'ld-sentinel';
    s.setAttribute('aria-hidden', 'true');
    s.__ldTarget = el;
    // Sentinel mirrors the target's box via absolute positioning inside its parent.
    var parent = el.parentElement;
    if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
    s.style.cssText = 'position:absolute;left:0;right:0;pointer-events:none;visibility:hidden;display:block;';
    s.style.top = el.offsetTop + 'px';
    s.style.height = Math.max(1, el.offsetHeight) + 'px';
    parent.appendChild(s);
    io.observe(s);
  }

  /* ---------- 4. Before/after auto-sweep ---------- */
  function sweep(el) {
    if (el.dataset.swept) return;
    el.dataset.swept = '1';
    var range = el.querySelector('.ld-case__range');
    var start = null;
    var wait = 300;
    var DUR = 2200;

    function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

    function frame(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / DUR);
      // 50 → 4 → 96 → 50
      var p = ease(t);
      var v;
      if (p < 0.33) v = 50 - (46 * (p / 0.33));
      else if (p < 0.72) v = 4 + (92 * ((p - 0.33) / 0.39));
      else v = 96 - (46 * ((p - 0.72) / 0.28));
      el.style.setProperty('--ld-split', v + '%');
      if (range) range.value = Math.round(v);
      if (t < 1 && !el.dataset.touched) requestAnimationFrame(frame);
      else { el.style.setProperty('--ld-split', (el.dataset.touched ? range.value : 50) + '%'); }
    }

    if (range) {
      range.addEventListener('pointerdown', function () { el.dataset.touched = '1'; }, { once: true });
    }
    setTimeout(function () { requestAnimationFrame(frame); }, wait);
  }

  function compare() {
    var cards = document.querySelectorAll('[data-ld-compare]');
    Array.prototype.forEach.call(cards, function (el) {
      if (!io) return;
      watch(el);
    });
  }

  onReady(function () {
    if (!motionOK) {
      // Reduced motion / no flag: make sure nothing stays hidden.
      Array.prototype.forEach.call(document.querySelectorAll('.ld-hero'), function (el) { el.classList.add('is-ready'); });
      Array.prototype.forEach.call(document.querySelectorAll('[data-ld-highlight]'), function (w) { w.setAttribute('animate', ''); });
      return;
    }
    hero();
    compare();
  });

  document.addEventListener('shopify:section:load', function () {
    if (!motionOK) return;
    hero(); compare();
  });
})();
